import styled from "styled-components";

interface InputProps {
  inline?: boolean;
}

export const Input = styled.input<InputProps>`
  font-size: 1rem;
  background-color: ${(props) => props.theme.colors.INPUT_BACKGROUND};
  border: 1px solid ${(props) => props.theme.colors.BORDER_COLOR};
  font-family: "Spartan", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif;
  padding: 1rem 0.6rem 1rem 1.2rem;
  line-height: normal;
  width: 16rem;
  margin-top: 1rem;

  &:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 500px
      ${(props) => props.theme.colors.BORDER_COLOR} inset;
  }

  &::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #c4c4c4;
  }

  &::-moz-placeholder {
    /* Firefox 19+ */
    color: #c4c4c4;
  }

  &:-ms-input-placeholder {
    /* IE 10+ */
    color: #c4c4c4;
  }

  &:-moz-placeholder {
    /* Firefox 18- */
    color: #c4c4c4;
  }

  &[type="number"]::-webkit-inner-spin-button,
  &[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const InputWrapper = styled.div`
  margin-top: 1rem;
`;

export const ErrorWrapper = styled.div`
  height: 1rem;
  span {
    display: block;
    margin-top: 0.5rem;
    color: ${(props) => props.theme.colors.ERROR_MESSAGE};
    font-size: 0.9rem;
    font-weight: 600;
    text-align: left;
  }
`;
